<div class="content">
  <div class="wz-head">
    <span class="wz-eyebrow">World Creation Wizard</span>
    <h2 class="wz-title">{{ mapName ? mapName + ' ' : '' }}<span class="gold">resources</span></h2>
    <span class="wz-step">Part {{ currentPart }} of 2</span>
  </div>

  @if (currentPart === 1) {
    <p class="wz-lead">
      Five resource categories shape how materials are spread across your map. <strong>5 is normal</strong>; lower makes a
      category scarcer, higher makes it more common.
    </p>
  }

  <div class="rc-list">
    @for (row of pages[currentPart]; track row.key) {
      <div class="wz-card rc-row">
        <img class="rc-img" [src]="row.image" [alt]="row.name + ' resources'" />
        <div class="rc-body">
          <p class="rc-name">{{ row.name }}</p>
          <p class="wz-muted rc-text">{{ row.text }}</p>

          <div class="rc-slider">
            <span class="rc-value" aria-hidden="true">{{ value(row.key) }}<small>/10</small></span>
            <input type="range" class="rc-range" min="1" max="10" step="1"
              [value]="value(row.key)" (input)="onSliderChange(row.key, $event)"
              [style.--fill]="((value(row.key) - 1) / 9) * 100 + '%'"
              [attr.aria-label]="row.name + ' availability'" [attr.aria-valuetext]="value(row.key) + ' of 10, ' + level(value(row.key)).name" />
          </div>
          <p class="rc-level"><strong>{{ level(value(row.key)).name }}</strong> · {{ level(value(row.key)).text }}</p>
        </div>
      </div>
    }
  </div>

  <div class="wz-actions">
    <button type="button" class="btn btn-dark" (click)="onBack()">Back</button>
    <button type="button" class="btn btn-theme" (click)="onNext()">Next</button>
  </div>
</div>
